<script setup>
</script>

<template>
  <router-view />
</template>

<style>
html,
body,
#app {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar,
#app::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

#app {
  overflow-x: hidden;
}
</style>
